/* Built In Imports */
import React from 'react';

/* External Imports */
import { Box, Image, Text } from '@chakra-ui/react';
import Slider from 'react-slick';

/* Internal Imports */
/* Services */

/* Styles */
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';

/**
 * Renders the Testimonials component
 *
 * @param {object} sectionContent - Data for section
 * @param {string} region - Region of the section
 * @param {string} lang - Language of the section
 * @returns {ReactElement} Testimonials component
 */

const Testimonials = ({ sectionContent, region, language }) => {
  const testimonialData = sectionContent.body.find(
    el => el.sectionId == 'Section-3'
  );
  const settings = {
    responsive: [
      {
        settings: {
          autoplay: true,
          speed: 1000,
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false,
          mobileFirst: false,
        },
      },
    ],
  };
  return (
    <>
      <Text
        fontSize={{ base: '12px', md: '16px' }}
        color="#ffbd31"
        margin="0 0 5px 0"
        letterSpacing="1.5px"
        fontFamily="FedraSansStd-book"
        textTransform="uppercase"
      >
        {testimonialData?.sectionContent[0]?.titleSubtext}
      </Text>
      <Text
        as="h2"
        fontSize={{ lg: '50px', base: '24px' }}
        fontFamily="FedraSansStd-A-medium"
        color="#ffffff"
        p={{ base: '0 20px', md: 'unset' }}
      >
        {testimonialData?.sectionContent[0]?.titleText}
      </Text>
      <Box
        margin="120px auto 0"
        width={{ lg: '44%', base: '100%' }}
        className="testimonials-slider"
      >
        <Slider {...settings} className={`${'mmm-intro-slider'} `}>
          {testimonialData?.sectionContent[1]?.testimonials?.map((el, i) => {
            return (
              <Box
                boxShadow="0 0 30px rgb(0 0 0 / 20%) !important"
                w={{ base: '90% !important', md: '95% !important' }}
                background="#e4ded4"
                padding="25px 25px"
                borderRadius="12px"
                marginRight="30px"
                margin={{ base: '0 auto', lg: '0 30px 0 0' }}
                id={i}
              >
                <Box margin="0 auto">
                  <Image
                    src={el.photo?.url}
                    margin="-107px 0 0 0"
                    borderRadius="50%"
                    width={{ base: '120px', lg: '120px' }}
                    display="inline-block !important"
                  ></Image>
                  <Box
                    background="url(/assets/images/quote.png) 17px 13px no-repeat"
                    padding="35px 0 0 0"
                    textAlign="left"
                    color="#121212"
                  >
                    <Text
                      padding="0 10px 30px 10px"
                      fontSize={{ base: '16px', lg: '22px' }}
                      fontFamily="FedraSansStd-book"
                      lineHeight="26px"
                    >
                      {el.testimonialText}
                    </Text>
                    <Box
                      borderTop="solid 2px rgba(18, 18, 18, 0.15)"
                      padding="30px 0 0 0"
                      fontSize={{ base: '18px', md: '20px' }}
                      textAlign="center"
                    >
                      <Text fontFamily="FedraSansStd-A-medium">
                        {el.userName}
                      </Text>
                      <Text fontFamily="FedraSansStd-book">
                        {el.userDescription}
                      </Text>
                    </Box>
                  </Box>
                </Box>
              </Box>
            );
          })}
        </Slider>
      </Box>
      <style global jsx>{`
        .testimonials-slider .slick-slider .slick-list {
          overflow: visible;
        }
        .testimonials-slider .slick-slider {
          text-align: center;
        }
        .testimonials-slider .slick-slider .slick-prev,
        .testimonials-slider .slick-slider .slick-next {
          background: url(../../../assets/images/top-arrow.svg) no-repeat;
          transform: rotate(267deg);
          width: 50px;
          height: 50px;
          background-size: 100%;
          top: 30%;
          left: -20px;
        }
        .testimonials-slider .slick-slider .slick-next {
          transform: rotate(90deg);
          right: 4px;
          left: unset;
        }
        .testimonials-slider .slick-slider .slick-prev:before,
        .testimonials-slider .slick-slider .slick-next:before {
          display: none;
        }
        .testimonials-slider .slick-slider .slick-prev,
        .testimonials-slider .slick-slider .slick-next {
          z-index: 2;
        }
        .testimonials-slider .slick-slider .slick-slide {
          opacity: 0.5;
        }
        .testimonials-slider .slick-slider .slick-current {
          opacity: 1;
        }
        .clear {
          clear: both;
        }
        @media screen and (max-width: 768px) {
          .testimonials-slider .slick-slider .slick-prev,
          .testimonials-slider .slick-slider .slick-next {
            width: 40px;
            height: 40px;
          }
          .testimonials-slider .slick-slider .slick-prev {
            left: 2px;
          }
          .testimonials-slider .slick-slider .slick-next {
            right: 2px;
          }
        }
      `}</style>
    </>
  );
};

export default Testimonials;
